import * as React from 'react';

const AuthenticityDiamondFilled16 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m.582 7.579 5.69 6.195c.919.968 2.537.968 3.456 0l5.69-6.195a2.053 2.053 0 0 0 .005-2.859l-2.347-2.489a2.38 2.38 0 0 0-1.733-.731H4.657c-.663 0-1.295.266-1.733.731L.577 4.721a2.053 2.053 0 0 0 .005 2.858m9.952-2.11 1.21.415a.43.43 0 0 1 .186.15.39.39 0 0 1 0 .442.43.43 0 0 1-.187.15l-1.209.405-.41 1.206a.37.37 0 0 1-.14.19.41.41 0 0 1-.466 0 .37.37 0 0 1-.14-.19l-.4-1.206-1.209-.405a.43.43 0 0 1-.195-.15.39.39 0 0 1 0-.453.43.43 0 0 1 .195-.149l1.21-.405.399-1.206a.37.37 0 0 1 .14-.19.41.41 0 0 1 .466 0 .37.37 0 0 1 .14.19z"
  }
));
AuthenticityDiamondFilled16.Size = 16;
AuthenticityDiamondFilled16.Title = "AuthenticityDiamondFilled";

export { AuthenticityDiamondFilled16 as default };
